export default class Anchor {
    #anchorElem;
    #id;
    #upperBorder;
    #lowerBorder;

    constructor(
        anchorElem,
        id,
        upperBorder=null,
        lowerBorder=null
    ) {
        this.#anchorElem = anchorElem  
        this.#id = id 
        this.#upperBorder = upperBorder   
        this.#lowerBorder = lowerBorder   
    }

    // getters
    get anchorElem() {
        return this.#anchorElem
    }
    get id() {
        return this.#id;
    }
    get upperBorder() {
        return this.#upperBorder
    }
    get lowerBorder() {
        return this.#lowerBorder
    }

    // setters
    set anchorElem(elem) {
        this.#anchorElem = elem
    }
    set id(id) {
        this.#id = id;
    }
    set upperBorder(val) {
        this.#upperBorder = val
    }
    set lowerBorder(val) {
        this.#lowerBorder = val
    }
}
